import { Component, SimpleChanges, OnDestroy, OnInit, HostListener } from '@angular/core';
import { StorageService } from './service/storage.service';
import { Subscription, delay } from 'rxjs';
import { LoaderService } from './service/loader.service';
import { AuthService } from './service/auth.service';
import { LanguageService } from './service/language.service';
import { CommonService } from './service/common.service';
import { UuidService } from './service/uuid.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'fixz';
  isLoggedIn: boolean = false;
  storage$: Subscription = new Subscription();
  isLoading = false;
  sidebarOpen: boolean = true;
  isMobile: boolean = false;
  
  constructor(
    public storage: StorageService, 
    public loading: LoaderService, 
    private auth: AuthService, 
    private languageService: LanguageService, 
    private commonService: CommonService,
    private uuidService: UuidService
  ) {
    this.storage$ = this.storage.getItem('local', 'authData').subscribe((user: any) => {
      if(user) {
        this.isLoggedIn = true;
      }else {
      this.isLoggedIn = false;
      }
    });
  }

  ngOnInit(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.listenToLoading();
    this.auth.generateSideNav();
    this.detectMobileScreen();
    this.listenToSidebarState();
    // ensure language applied early
    try {
      // LanguageService constructor applies stored/browser language
    } catch (e) {}
    
  }

  listenToSidebarState(): void {
    this.commonService.sidebarOpen$.subscribe(isOpen => {
      this.sidebarOpen = isOpen;
    });
    
    this.commonService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkIsMobile();
  }

  private checkIsMobile(): void {
    const isMobile = window.innerWidth <= 480;
    this.commonService.isMobile$.next(isMobile);
  }

  detectMobileScreen(): void {
    // Check initial screen size
    this.checkIsMobile();
  }

  listenToLoading(): void {
    this.storage$ = this.loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.isLoading = loading;
      });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.storage$.unsubscribe();
  }
}
